import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import MainBanner from '../components/HomeDemoTwo/MainBanner';
import FeaturedService from '../components/HomeDemoTwo/FeaturedService';
import AboutServicesSection from '../components/HomeDemoTwo/AboutServicesSection';
import ServicesCard from '../components/Common/ServicesCard';
import WhatWeDo from '../components/Common/WhatWeDo';
import TestimonialStyleTwo from '../components/Common/TestimonialStyleTwo';
import CaseStudies from '../components/Common/CaseStudies';
import Partner from '../components/Common/Partner';
import OurTeamStyleTwo from '../components/Common/OurTeamStyleTwo';
import Pricing from '../components/Common/Pricing';
import StartProjectWithUs from '../components/Common/StartProjectWithUs';
import LatestBlogPost from '../components/Common/LatestBlogPost';
import Footer from '../components/App/Footer';

const HomeTwo = () => {
    return (
        <Layout>
            <SEO title="Grow Your Business with AI" description='At cimplify.ai, we help companies harness the power of artificial intelligence to drive growth, enhance productivity, improve efficiency and scale operations.'/>
            <NavbarStyleTwo />
            <MainBanner />
            
            <FeaturedService />
            <Partner />
            <AboutServicesSection />
            {/* <WhatWeDo /> */}
            {/* <TestimonialStyleTwo /> */}
           
            {/* <CaseStudies /> */}
            <ServicesCard />
            
         
            <StartProjectWithUs />
            <Partner /> 
            <Footer />
            
            
        </Layout>
    )
    
}

export default HomeTwo;